import { parseDateTime } from '@Utils/transformDateTime';
import { MSkeleton } from '@Components/Base';
import { SoftwareAssets } from '@Types/api/common/dictionary/AssetsResponse';

import { ViewResolver } from '@Components/ViewResolver';
import CardDesktop from '../components/desktop/CardDesktop';
import CardMobile from '../components/mobile/CardMobile';
import { CardType } from '../type';

interface SoftwareTabProps {
  data: Array<SoftwareAssets>;
  isSuccess: boolean;
}

const SoftwareTab: React.FC<SoftwareTabProps> = ({ data, isSuccess }) => {
  const mapData: Array<CardType> = data.map((item) => ({
    id: item.AssetID,
    cardItems: [
      {
        label: 'Brand',
        value: item.Brand,
      },
      { label: 'Sub Type', value: item.Subtype },
      { label: 'Version', value: item.Version },
      { label: 'License Type', value: item.LicenseType },
      { label: 'Expiry Date', value: parseDateTime(item.ExpiryOn) },
    ],
    iconType: item.Software,
    isActionHandling: false,
    nameAsset: item.Software,
    numberAsset: item.AssetNo,
  }));

  if (!isSuccess) {
    return <MSkeleton />;
  }

  return (
    <>
      {mapData.map((cardDataItem) => (
        <ViewResolver
          key={cardDataItem.id}
          desktop={<CardDesktop dataCard={cardDataItem} />}
          mobile={<CardMobile dataCard={cardDataItem} />}
        />
      ))}
    </>
  );
};

export default SoftwareTab;
